/**
 * The Insights tab an insight was opened from, as it rides in the insight's link (`?from=snoozed`); Open needs none.
 * Kept apart and import-free: route search validation runs in the first load.
 */
export type InsightFrom = "mine" | "snoozed" | "done";

export function fromOf(v: unknown): InsightFrom | undefined {
  return v === "mine" || v === "snoozed" || v === "done" ? v : undefined;
}
